//@flow
import * as React from 'react';
// $$FlowFixMe
import Textarea from 'react-textarea-autosize';
import styles from './CaptionTextarea.module.scss';

export const CaptionTextarea = (props: *) => {
  return (
    <Textarea
      {...props}
      rows="1"
      className={`form-control ${styles['form-control--caption-textarea']}`}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/MediaUpload/CaptionTextarea.js